import type { LoginResult, Me, OtpChallenge, OtpChannel } from '@mira/shared/auth'
import { api } from '@/lib/api'
import { ApiError, unwrap } from '@/lib/api-error'

const login = api.auth.login

export const authApi = {
  password: (json: { phone: string; password: string; channel?: OtpChannel }) =>
    unwrap<OtpChallenge>(login.password.$post({ json })),
  deviceChallenge: (deviceId: string) => unwrap<{ nonce: string }>(login.device.challenge.$post({ json: { deviceId } })),
  device: (json: { deviceId: string; nonce: string; signature: string; channel?: OtpChannel }) =>
    unwrap<OtpChallenge>(login.device.$post({ json })),
  resend: (challengeId: string, channel?: OtpChannel) => unwrap<OtpChallenge>(login.otp.resend.$post({ json: { challengeId, channel } })),
  verify: (json: { challengeId: string; code: string; rememberDevice?: { publicKey: Record<string, unknown>; label: string } }) =>
    unwrap<LoginResult>(login.otp.verify.$post({ json })),
  /** Current user, or null when signed out. */
  me: async (): Promise<Me | null> => {
    try {
      return await unwrap<Me>(api.me.$get())
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) return null
      throw err
    }
  },
  logout: () => fetch('/api/auth/sign-out', { method: 'POST', headers: { 'content-type': 'application/json' }, body: '{}' }),
}
